import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { Alert, Avatar, Button, Container, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { NavSections } from '../navigation/NavSections';
import { isValidPassword, isValidUsername, passwordReminder } from './common';
const debug = process.env.REACT_APP_DEBUG && false;
const NewPassword = ({ isAuthenticated, cognitoUser, setNewPassword }) => {
    const [username, setUsername] = useState(cognitoUser?.getUsername() ?? undefined);
    const [password, setPassword] = useState(undefined);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(undefined);
    const [message, setMessage] = useState(undefined);
    debug && console.log('New Password', { cognitoUser, username });
    const newPasswordForm = (_jsxs("form", { noValidate: true, onSubmit: (e) => e.preventDefault(), children: [_jsx(TextField, { id: 'username',
                name: 'username',
                value: username,
                label: 'Username',
                variant: 'outlined',
                margin: 'dense',
                required: true,
                fullWidth: true,
                contentEditable: cognitoUser === undefined,
                disabled: cognitoUser !== undefined,
                autoFocus: cognitoUser === undefined,
                helperText: username === undefined || username.length === 0
                    ? 'Please enter your username'
                    : !isValidUsername(username)
                        ? `Usernames must be 4 or more characters long`
                        : undefined,
                onChange: (e) => setUsername(e.target.value) }, 'username'), _jsx(TextField, { id: 'password',
                name: 'password',
                label: 'New password',
                value: password,
                variant: 'outlined',
                margin: 'dense',
                required: true,
                fullWidth: true,
                autoFocus: cognitoUser !== undefined,
                autoComplete: 'new-password',
                type: showPassword ? 'text' : 'password',
                error: !!password && !isValidPassword(password),
                helperText: password === undefined || password.length === 0
                    ? 'Please enter a new password'
                    : password && !isValidPassword(password)
                        ? passwordReminder
                        : undefined,
                onChange: (e) => setPassword(e.target.value),
                InputProps: {
                    endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { "aria-label": "toggle password visibility", onClick: () => setShowPassword(!showPassword), children: showPassword ? _jsx(Visibility, {}) : _jsx(VisibilityOff, {}) }) })),
                } }, 'password'), error && (_jsx(Alert, { severity: "error", onClose: () => setError(undefined), sx: { marginBlockEnd: 1 }, children: error })), message && (_jsx(Alert, { severity: "info", onClose: () => setMessage(undefined), sx: { marginBlockEnd: 1 }, children: message })), _jsx(Button, { type: 'submit',
                variant: 'contained',
                fullWidth: true,
                disabled: !username || !isValidUsername(username) || !password || !isValidPassword(password),
                onClick: () => {
                    if (cognitoUser && password) {
                        setNewPassword(cognitoUser, password);
                        setError(undefined);
                        setMessage(undefined);
                    }
                }, children: "Set New Password" })] }));
    return (_jsx(Container, { component: "main", maxWidth: "xs", sx: { paddingBlock: 1 }, children: _jsxs(Stack, { gap: 1, children: [_jsxs(Stack, { direction: "row", justifyContent: "center", alignItems: "center", gap: 1, children: [_jsx(Avatar, { children: _jsx(LockOutlined, {}) }), _jsx(Typography, { variant: "h5", children: "Set New Password" })] }), newPasswordForm, !isAuthenticated && _jsx(Link, { to: `/${NavSections.LOGIN}`, children: "Back to login" })] }) }));
};
export default NewPassword;
